<template>
    <div class="card">
        <div class="flex-column p1">
            <div class="card_image">

                <el-image :src="GetImagePath" :preview-src-list="[GetImagePath]" fit="cover"
                    style="width: 100%; height: 100%" />
            </div>
            <div class="box_con  ">
                <div class="flex-row middle p1">
                    <div class="flex-row left wf f16b">{{ value.Name }}</div>

                </div>
                <div class="flex-row left wf p1 border-top start middle">
                    <div class="f14 wf">章节数:{{ ChapterCount }} <div>视频数:{{ LessonCount }}</div>
                    </div>
                    <div class="f14 wf flex-row middle end">

                        <div> <el-button plain size="mini" @click="onShowDialog">查看章节</el-button></div>
                    </div>

                </div>
                <div class="flex-row end wrap list-half   border-top divider">
                    <div class='wf p1 pointer f14 button' @click="onAddChapter">添加章节</div>
                    <div class="wf p1 pointer  f14" @click="OnPlay" v-if="value.VideoPath">
                        预览

                    </div>
                    <div class="  p1 pointer button" v-if="IsDetail" @click="OnGoDetail">
                        详情
                    </div>
                    <div class='  p1 pointer' v-if="!GetDisabled('modify')" @click="OnModify">
                        <a class="button" href="javascript:void(0)">编辑</a>
                    </div>
                    <div class="  p1 pointer" v-if="!GetDisabled('del')" @click="OnDelete">
                        <a class="button" href="javascript:void(0)">删除</a>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog title="章节明细" :visible.sync="Show" width="40%" @close="onDialogClose">
            <mx-page type="Home" theme="Panel" :config="config" title="章节明细" :key="'章节明细'" :name="'章节明细'" :parent='value' :parent-type="Config.Type" />
        </el-dialog>
        <el-dialog :visible.sync="dialogTableVisible" @close="onDialogClose">
            <video :src="SiteUrl + value.VideoPath" controls class="video" width="100%" ref="dialogVideo"></video>
        </el-dialog>
    </div>
</template>
<script>
import base from "matrix.node.ui/libs/panels/base.js";
export default {
    props: {
        config: Object,
        value: Object,
        index: Number,
        role: String,
        roleField: String,
        name: String,
    },
    mixins: [base],
    data() {
        return { IsModify: false, IsDelete: false, dialogTableVisible: false, Show: false };
    },
    computed: {
        Config() {
            return Object.assign(
                { EventName: this.name ? this.name : "TypeEvent", IsDark: false },
                this.config
            );
        },
        SiteUrl() {
            return this.$matrix.Config.ImageSite;
        },
        IsDetail() {
            if (this.config.DetailView) return true
            return false
        },
        GetImagePath() {
            if (this.value.Image) return this.SiteUrl + this.value.Image
            if (this.value.FaceImage) return this.SiteUrl + this.value.FaceImage
            return this.SiteUrl + this.value.Image
        },
        ChapterCount() {
            if (this.value && this.value.ChapterList && this.value.ChapterList.length) return this.value.ChapterList.length
            return 0
        },
        LessonCount() {
            if (this.value && this.value.ChapterList && this.value.ChapterList.length) {
                return this.value.ChapterList.reduce((t, n) => {
                    if (n.ItemsList && n.ItemsList.length) {
                        return t += n.ItemsList.length
                    }
                    return t
                }, 0)
            }
            return 0
        }


    },
    methods: {

        OnEvent(e) {
            this.$emit("event", e);
        },
        OnGoDetail() {
            let View = this.config.DetailView;

            if (!View) return this.$matrix.ShowError("未配置详情视图");
            this.$emit("goview", {
                View: View,
                ViewType: "详情",
                Data: this.value,
                Role: this.config.Role,
                RoleField: this.config.RoleField,
            });
        },
        OnPlay() {
            this.dialogTableVisible = true
            this.$refs.dialogVideo.play();

        },
        onDialogClose() {
            if (this.value.VideoPath) {
                this.$refs.dialogVideo.pause();
            }
            this.$emit('event', {
                target: 'item',
                name: 'Reload'
            })

        },
        onAddChapter() {
            this.$matrix.AddData(
                this.Context,
                {},
                {
                    Type: 'Lesson.Chapter',
                    Role: this.config.Role,
                    RoleField: this.config.RoleField,
                    Roles: this.config.Roles,
                    RoleFieldData: this.config.RoleFieldData
                },
                (data) => {
                    this.$emit('event', {
                        target: 'item',
                        name: 'Reload'
                    })
                },
                this.value
            )
        },
        onShowDialog() {
            this.Show = true
        },

    },
};
</script>

<style scoped>
.card {
    width: 20%;
    overflow: hidden;
    margin-bottom: 20px;
}

.card_image {
    height: 240px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    overflow: hidden;
}

.box_con {
    background: #f7f8fa;
}

.button {
    font-size: 14px;
    color: #409eff;
}

.mt5 {
    margin-top: 5px;
}

.border-top {
    border-top: 1px solid #ebebeb;
}


.divider .wf {
    position: relative;
}

.divider .wf::after {
    content: " ";
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    border-right: 1px solid #ebebeb;
    width: 1px solid #ebebeb;
}

.divider .wf:last-child::after {
    display: none;
}
</style>